import moment from 'moment';

export const processes = [
  {
    spare_part_id: null,
    breakdown_details: '',
    action_taken: '',
    remarks: '',
  },
];

export const initialState = {
  isSubmitted: false,
  is_admin_request_no: null,
  is_admin_request: null,
  moduleData_Date: moment(),
  type_of_breakdown: '', // option mechanical , electrical , electronic , fixture
  machine_id: null,
  department_id: null,
  time: null,
  machine_handover_date:null,
  machine_handover_time:null,
  breakdown_hrs: null,
  supervisor_prod:'',
  supervisor_mtc:'',
};
